import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import Goals from "@/pages/Goals";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/goals")({
  head: () => seoHead("/goals"),
  component: () => (
    <AuthGate><Goals /></AuthGate>
  ),
});
